/* istanbul ignore file */

import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import createReduxWaitForMiddleware from "redux-wait-for-action";
import createFilter from "redux-persist-transform-filter";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { createGoogleAnalyticsMiddleware } from "./googleAnalytics";
import reducers from "./reducers";
import rootSaga from "./sagas";

/**
 * Configure Redux store
 * Note: With React Router v6, routing state is managed by the router itself
 * and no longer needs to be kept in Redux
 */
export const configureStore = initialState => {
  const sagaMiddleware = createSagaMiddleware();

  const composeEnhancers =
    (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 45 })) ||
    compose;

  const persistConfig = {
    key: "root",
    storage,
    whitelist: ["appConfig", "login"],
    transforms: [
      createFilter("appConfig", ["prospect.applicationInfo.financeType"]),
      createFilter("login", ["loginStatus"])
    ]
  };

  const store = createStore(
    persistReducer(persistConfig, reducers()),
    initialState,
    composeEnhancers(
      applyMiddleware(
        createGoogleAnalyticsMiddleware(),
        sagaMiddleware,
        createReduxWaitForMiddleware()
      )
    )
  );

  sagaMiddleware.run(rootSaga);

  return { store };
};
